var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"options":_vm.options,"value":_vm.value,"disabled":_vm.disabled,"multiple":_vm.multiple},on:{"input":_vm.onIput}})
}
var staticRenderFns = []

export { render, staticRenderFns }